import { api } from "../api"
import * as programApi from "./programs"
import * as sensorApi from "./sensors"
import * as userApi from "./users"
import { API_CARD_ROOT_ENDPOINT } from "./constants"

export const fetchUserCards = async (token) => {
    try {
        const response = await api.post(`${API_CARD_ROOT_ENDPOINT}/fetch_users_cards`, { ...token })
        const data = await response.json()

        return { data }
    } catch (err) {
        //throw err
    }
}

export const fetchCardStates = async (token) => {
    try {
        const response = await api.post(`${API_CARD_ROOT_ENDPOINT}/fetch_main_dashboard`, { ...token })
        if (!response.ok)
            return response.status

        const data = await response.json()

        return data
    } catch (err) {
        //throw err
    }
}

export const fetchCardSettings = async (metaData) => {
    try {
        const response = await api.post(`${API_CARD_ROOT_ENDPOINT}/fetch_card_properties`, metaData)
        if (!response.ok)
            return response.status

        const data = await response.json()

        return data
    } catch (err) {
       // throw err
    }
}

export const writeCardSettings = async (propertiesTable) => {
    try {
        const response = await api.post(`${API_CARD_ROOT_ENDPOINT}/write_card_properties`, propertiesTable)
        if (!response.ok)
            return response.status

    } catch (err) {
        //throw err
    }
}

export const fetchFaultCodes = async (metaData) => {
    try {
        const response = await api.post(`${API_CARD_ROOT_ENDPOINT}/fetch_faults`, metaData)
        if (!response.ok)
            return response.status

        const data = await response.json()

        return data
    } catch (err) {
       // throw err
    }
}

export const restoreFaultcodes = async (metaData) => {
    try {
        const response = await api.post(`${API_CARD_ROOT_ENDPOINT}/clear_fault_codes`, metaData)
        if (!response.ok)
            return response.status

    } catch (err) {
       // throw err
    }
}

export const fetchEvents = async (metaData) => {
    try {
        const response = await api.post(`${API_CARD_ROOT_ENDPOINT}/fetch_events`, metaData)
        if (!response.ok)
            return response.status

        const data = await response.json()

        return data
    } catch (err) {
       // throw err
    }
}

export const fetchNewEvents = async (token) => {
    try {
        const response = await api.post(`${API_CARD_ROOT_ENDPOINT}/fetch_new_events`, token)
        if (!response.ok)
            return response.status

        const data = await response.json()

        return data
    } catch (err) {
        // throw err
    }
}

export const fetchEventsMeta = async (metaData) => {
    try {
        const response = await api.post(`${API_CARD_ROOT_ENDPOINT}/fetch_event_meta`, metaData)
        if (!response.ok)
            return response.status

        const data = await response.json()

        return data
    } catch (err) {
       // throw err
    }
}

export const fetchCardData = async (metaData) => {
    try {
        const response = await api.post(`${API_CARD_ROOT_ENDPOINT}/fetch_single_card`, metaData)
        if (!response.ok)
            return response.status

        const data = await response.json()

        return data
    } catch (err) {
        // throw err
    }
}

export const rebootCard = async (metaData) => {
    try {
        const response = await api.post(`${API_CARD_ROOT_ENDPOINT}/reboot_device`, metaData)
        if (!response.ok)
            return response.status

    } catch (err) {
        // throw err
    }
}

export const getNotes = async (token) => {
    try {
        const res = await api.post(`/Card/get_notes`, token)

        if (!res.ok)// { res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status

        const data = await res.json()
        return data
    } catch (err) {
        // throw err
    }
}

export const writeNote = async (noteData) => {
    try {
        const response = await api.post(`${API_CARD_ROOT_ENDPOINT}/write_note`, noteData)
        if (!response.ok)
            return response.status

    } catch (err) {
        // throw err
    }
}

export const getIRLogs = async (token) => {
    try {
        const res = await api.post(`/Card/fetch_ir_logs`, token, true)

        if (!res.ok)// { res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status

        const data = await res.json()
        return data
    } catch (err) {
        // throw err
    }
}

// export const fetchCard = async (token, id, cardIndex) => {
//     try {
//         const res = await api.post(`${API_CARD_ROOT_ENDPOINT}/fetch_sensor_meta`, { ...token, cardId: id, cardIndex })
//         const data = await res.json()
//         return { data }
//     } catch (err) {
//         console.error("Error fetching card data:", err)
//         throw err
//     }
// }

export const { fetchAllPrograms, writeProgram, deleteProgram, setValveMode } = programApi
export const { fetchSensorValues, fetchSensorMeta, fetchCardDashboard, checkForUpdates, fetchSensorLog, fetchSensorConfig, saveSensorConfig } = sensorApi
export const { getOrganizations, getResellers, createNewAccount, createNewOrganization, getStrayCards, connectCard, getAccounts, removeOrganization, removeAccount, fetchSingleAccount, editAccount, registerPushNotification } = userApi
